import React, {useState} from "react"
import Pagination from "../components/Pagination"
import BasicButton from "../components/BasicButton";

function Intro(props) {
    const [page, setPage] = useState(props.page - 1 || 0)
    const allPagesAmount = 4

    function renderContent(title, text){
        return <>
            <figure className={"flex-center"}>
                <img className={"margin-auto"} src={'/images/intro/prodect-intro_' + (page + 1) + '.png'} alt={"Sivu " + page}/>
            </figure>
            <div className={"flex-grow padding"}>
                <h1 className={"text-center"}>{title}</h1>
                {typeof text === 'string' ? <p>{text}</p> : text}
                {page < allPagesAmount - 1 ?
                    <div className={"btn-set_right"}>
                        <BasicButton
                            icon={"chevron-right"}
                            iconColor={"light"}
                            action={()=> setPage(page + 1)}
                        />
                    </div> : null}
            </div>
        </>
    }

    function renderDefaultPage() {
        return renderContent('Projektin kaikki tiedot yhdessä paikassa', <>
            <p>Prodect keskittää kaiken tarvittavan tiedon ja yhdistää projektin jokaisen toimijan: suunnittelusta työnjohtoon, alihankkijoista aina työmaan yksittäisiin ammattiosaajiin.</p>
        </>)
    }

    function renderPage(){
        switch (page) {
            case 0:
                return renderDefaultPage()

            case 1:
                return renderContent('Yhteinen onnistuminen', <>
                    <p>Kaikki haluavat projektin onnistuvan – täyttää sen tavoitteet, tehdä työnsä mahdollisimman hyvin ja kannattavasti, ja viedä projektin aikataulussa maaliin.</p>
                </>)

            case 2:
                return renderContent('Tieto parantaa tulosta. Prodect parantaa tietoa.', <>
                    <p>Kaikilla sama, jatkuvasti päivittyvä, tieto aina saatavilla, paikasta riippumatta.</p>
                </>)

            case 3:
                return renderContent('Kerää vain ne tiedot joita tarvitset',
                    'Projektin valmistuttua, se voidaan arkistoida myöhempää käyttöä varten. Käytä oppimaasi pohjana seuraavassa projektissa. ')

            default:
                return renderDefaultPage()
        }
    }
    return <section className={"card-intro element-set"}>
        <div className={"display-flex-v dark-mode"}>
            {renderPage(page)}
            <div className={"flex-center text-center"}>
                <Pagination
                    btnClass={"3rd"}
                    currentPage={page}
                    allItemsInt={allPagesAmount}
                    callback={(val)=> setPage(val)}
                    showPages
                    disableLoop
                    className={"btn-set margin-top"}
                />
            </div>
        </div>
    </section>
}

export default Intro